export const getCache = (cb, page, isNoDelete) => {
  if (localS('cacheName') === page) {
    cb && cb(localS('cache'))
    !isNoDelete && clearCache()
  } else {
    cb && cb()
    !isNoDelete && clearCache()
  }
}
export const setCache = (page, info) => {
  localS('cache', info)
  localS('cacheName', page)
}
export const clearCache = () => {
  localS('cache', null)
  localS('cacheName', null)
}
export const localS = (key, value) => {
  if (typeof value === 'undefined') {
    if (typeof key === 'object') {
      for (let k in key) {
        if (key[k] === null) localStorage.removeItem(k)
        else {
          if (typeof key[k] === 'object') key[k] = JSON.stringify(value)
          window.localStorage[k] = key[k]
        }
      }
    } else {
      let value = window.localStorage[key]
      try {
        value = JSON.parse(value)
        return value
      } catch (e) {
        return value
      }
    }
  } else {
    if (value === null) localStorage.removeItem(key)
    else {
      if (typeof value === 'object') value = JSON.stringify(value)
      window.localStorage[key] = value
    }
  }
}

export default {
  getCache,
  setCache,
  clearCache,
  localS
}
